import { render, staticRenderFns } from "./distanced_function.vue?vue&type=template&id=59c7e673"
import script from "./distanced_function.vue?vue&type=script&lang=js"
export * from "./distanced_function.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports